module.exports = __webpack_public_path__ + "img/aaba134.png";